import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import { AuthProvider, AuthProviderProps } from "react-oidc-context";
import { IceLogout } from "./IceLogout";
import { IceLogin } from "./IceLogin";
import { User, WebStorageStateStore } from "oidc-client-ts";
import { IdleWatch } from "../IdleWatch/IdleWatch";
import { LoanFilterDialog } from "../LoanFilterDialog/LoanFilterDialog";

// @ts-ignore
const ICE_SSO_HOST = window.env.ICE_SSO_HOST;

export const ICE_SSO_AUTHORITY = `https://${ICE_SSO_HOST}/oidcauth`;
export const ICE_SSO_CLIENT_ID = "MSP_DX";

const onSigninCallback = (_user: User | undefined): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

const iceAuthProps: AuthProviderProps = {
  metadataUrl: `https://${ICE_SSO_HOST}/oidcconfig/${ICE_SSO_CLIENT_ID}/.well-known/openid-configuration`,
  authority: ICE_SSO_AUTHORITY,
  client_id: ICE_SSO_CLIENT_ID,
  redirect_uri: window.location.origin + "/auth/login",
  post_logout_redirect_uri: window.location.origin + "/auth/logout",
  scope: "openid profile email",
  onSigninCallback: onSigninCallback,
  userStore: new WebStorageStateStore({
    store: localStorage,
  }),
  accessTokenExpiringNotificationTimeInSeconds: 60,
};

export const IceAuthRouter = () => {
  return (
    <AuthProvider {...iceAuthProps}>
      <Router>
        <Routes>
          <Route path="/auth/login" element={<IceLogin />} />
          <Route path="/auth/logout" element={<IceLogout />} />
          <Route path="/*" element={<IdleWatch timeout={1_800_000} promptBeforeIdle={60_000} />} />
        </Routes>
      </Router>
      <LoanFilterDialog />
    </AuthProvider>
  );
};
